import { useFormik } from 'formik';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import Select from 'react-select';
import { Card } from '@components/card/card';
import { CardBody, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useAppDispatch } from '@store/hooks';
import SwalAlert from '@components/Shared/Alert/SwalAlert';
import { useNavigate } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import { addPurchaseRequest } from '@store/purchases/PurchaseRequests/purchaseRequestsSlice';
import useGetCategoriesList from '@hooks/INV/useGetCategoriesList';
import PRLines from './PRLines';
import { AddPurchaseRequestSchema } from '../../../ValidationForm/validationSchema';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import { TreeSelect } from 'antd';
import { useEffect, useMemo, useState } from 'react';


const Add = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { OperatingUnitOptions, loading: loading3 } = useGetOperatingUnitWithPermission();
  const { InventoryOptions, loading: loading4 } = useGetInventoryWithPermission();
  const { loading: loading5, treeCategoriesData } = useGetCategoriesList();

  // ✅ Modal selection state
  const [showSelectionModal, setShowSelectionModal] = useState(true);
  const [selectedOperatingUnit, setSelectedOperatingUnit] = useState<any>(null);
  const [selectedInventory, setSelectedInventory] = useState<any>(null);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);

  //#region Formik
  const formik = useFormik({
    initialValues: {
      isAme: false,
      categoryId: null,
      organizationId: '',
      peopleId: '',
      recipientname: '',
      billToLocationId: '',
      shipToLocationId: '',
      referenceId: '',
      transactionDate: '',
      deliveryDate: '',
      expirationDate: '',
      dueDate: '',
      paymentTermsId: '',
      paymentMethodId: '',
      description: '',
      grossAmount: '',
      discountRate: '',
      discountAmount: '',
      vat: '',
      netAmount: '',
      contractId: '',
      ameStatus: '',
      personId: '',
      paymentTerms: '',
      deliveryTerm: '',
      inventoryId: '',
      waybill: '',
      phone: '',
      currencyCode: '',
      currencyConversionRate: '',
      batchId: '',
      transactionsLinesList: [
        {
          description: '',
          discountAmount: 0,
          discountRate: 0,
          itemId: '',
          lineNumber: 0,
          price: 1,
          qty: 1,
          total: 0,
          uom: '',
          vatAmount: 0,
          vatRate: 0,
          itemType: 'InventoryItem'
        }
      ]
    },

    enableReinitialize: true,
    validationSchema: AddPurchaseRequestSchema(t),
    onSubmit: values => {
      if (values.transactionsLinesList?.length === 0) {
        SwalAlert({ text: 'أدخل أصناف' });
        formik.setSubmitting(false);
        return;
      }

      dispatch(
        addPurchaseRequest({
          isAme: false,
          categoryId: values.categoryId,

          organizationId: values.organizationId,
          peopleId: values.peopleId || null,
          recipientname: values.recipientname,
          billToLocationId: null,
          shipToLocationId: null,
          referenceId: null,
          transactionDate: values.transactionDate,
          deliveryDate: values.deliveryDate || null,
          expirationDate: values.expirationDate || null,
          dueDate: values.dueDate || null,
          paymentTermsId: null,
          paymentMethodId: null,
          description: values.description,
          grossAmount: 0,
          discountRate: values.discountRate || 0,
          discountAmount: values.discountAmount || 0,
          vat: values.vat || 0,
          netAmount: 0,
          contractId: values.contractId || null,
          ameStatus: values.ameStatus || 0,
          personId: null,
          paymentTerms: values.paymentTerms,
          deliveryTerm: values.deliveryTerm,
          inventoryId: values.inventoryId || null,
          waybill: values.waybill,
          phone: values.phone,
          currencyCode: values.currencyCode,
          currencyConversionRate: values.currencyConversionRate || 0,
          batchId: values.batchId || null,

          transactionsLinesList: formik.values.transactionsLinesList?.map((item, idx) => ({
            itemId: item.itemType === 'UndefinedItem' ? null : item.itemId,
            itemType: item.itemType,
            lineNumber: ++idx,
            uom: item.uom,
            description: item.description,
            price: 0,
            qty: Number(item.qty),
            discountRate: 0,
            discountAmount: 0,
            vatRate: 0,
            total: 0,
            vatAmount: 0,
            inventoryId: values.inventoryId || null
          }))
        })
      )
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Add' });
            navigate('/PUR/PurchaseRequests', { replace: true });
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch(() => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  const { values, handleChange: formikhandleChange, errors, touched, setFieldValue, setFieldTouched } = formik;
  //#endregion
  console.log(errors);
  console.log(values);

  // ✅ 1) اختيار أول OU تلقائياً
  useEffect(() => {
    if (!OperatingUnitOptions?.length) return;
    if (!selectedOperatingUnit) {
      setSelectedOperatingUnit(OperatingUnitOptions[0]?.value || null);
    }
  }, [OperatingUnitOptions, selectedOperatingUnit]);

  // ✅ مخازن الوحدة المختارة
  const filteredInventoryOptions = useMemo(() => {
    return (InventoryOptions || []).filter((x: any) => x.operatingUnitId === selectedOperatingUnit);
  }, [InventoryOptions, selectedOperatingUnit]);

  // ✅ 2) اختيار أول Inventory تلقائياً عند تحديد OU
  useEffect(() => {
    if (!selectedOperatingUnit) return;

    const invs = (InventoryOptions || []).filter((x: any) => x.operatingUnitId === selectedOperatingUnit);
    if (!invs.length) {
      setSelectedInventory(null);
      return;
    }

    const stillValid = invs.some((x: any) => x.value === selectedInventory);
    if (!selectedInventory || !stillValid) {
      setSelectedInventory(invs[0]?.value || null);
    }
  }, [selectedOperatingUnit, InventoryOptions, selectedInventory]);

  // ✅ confirm selection from modal
  const handleSelectionConfirm = () => {
    if (!selectedOperatingUnit || !selectedInventory || !selectedCategory) return;

    setFieldValue('organizationId', selectedOperatingUnit);
    setFieldTouched('organizationId', true);

    setFieldValue('inventoryId', selectedInventory);
    setFieldTouched('inventoryId', true);

    setFieldValue('categoryId', selectedCategory);
    setFieldTouched('categoryId', true);

    setShowSelectionModal(false);
  };

  return (
    <div>
      <Breadcrumb
        BreadcrumbList={[
          { name: 'Home', link: ':moduleHome' },
          { name: 'طلبات الشراء', link: '/PUR/PurchaseRequests' },
          { name: 'طلب شراء جديد', link: null }
        ]}
        PageName='طلب شراء جديد'
      />

      <Form onSubmit={formik.handleSubmit}>
        <Card className='shadow mb-3'>
          <CardBody>
            <Loading loading={loading3 || loading4}>
              <div className='row'>
                {/* ✅ Category (Disabled بعد الاختيار من المودال) */}
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('الفئة')}</label>
                    <TreeSelect
                      showSearch
                      className='w-100'
                      treeLine
                      allowClear
                      disabled
                      value={formik.values.categoryId || ''}
                      treeData={treeCategoriesData}
                      treeNodeFilterProp='title'
                      placeholder={i18n.language === 'ar' ? 'إختر فئة' : 'Choose category'}
                      fieldNames={{ label: 'title', value: 'value', children: 'children' }}
                      style={{ width: '100%' }}
                    />
                    <div className='text-danger'>{touched.categoryId && (errors as any).categoryId}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('تاريخ طلب الشراء')}</label>
                    <Form.Control
                      className='form-control text-center'
                      type='date'
                      name='transactionDate'
                      onChange={formikhandleChange}
                      value={values.transactionDate || ''}
                    />
                    <div className='text-danger'>{touched.transactionDate && (errors as any).transactionDate}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('تاريخ التوريد')}</label>
                    <Form.Control
                      className='form-control text-center'
                      type='date'
                      name='deliveryDate'
                      onChange={formikhandleChange}
                      value={values.deliveryDate || ''}
                    />
                    <div className='text-danger'>{touched.deliveryDate && (errors as any).deliveryDate}</div>
                  </div>
                </div>

                {/* ✅ Operating Unit (Disabled بعد الاختيار من المودال) */}
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('الوحدة التشغيليـة')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={loading3}
                      isSearchable={true}
                      isClearable
                      options={OperatingUnitOptions}
                      value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger'>{touched.organizationId && (errors as any).organizationId}</div>
                  </div>
                </div>

                {/* ✅ Inventory (Disabled بعد الاختيار من المودال) */}
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('المخزن')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={loading4}
                      isSearchable
                      isClearable
                      options={InventoryOptions?.filter((f: any) => f.operatingUnitId === formik.values.organizationId)}
                      value={
                        formik.values.inventoryId &&
                        InventoryOptions?.find((f: any) => f.value === formik.values.inventoryId)
                      }
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger'>{touched.inventoryId && (errors as any).inventoryId}</div>
                  </div>
                </div>

                <div className='col-lg-9'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Note')}</label>
                    <Form.Control
                      autoComplete='off'
                      className='form-control'
                      as='textarea'
                      rows={1}
                      name='description'
                      onChange={formik.handleChange}
                      value={values.description}
                      isInvalid={!!(touched.description && (errors as any).description)}
                    />
                  </div>
                </div>
              </div>
            </Loading>
          </CardBody>
        </Card>

        <Card className='shadow mb-3'>
          {formik.values.categoryId !== null && formik.values.inventoryId && (
            <>
              <PRLines formik={formik} />
              {touched.transactionsLinesList && (errors as any).transactionsLinesList?.length && (
                <div className='text-danger'> * مطلوب </div>
              )}
            </>
          )}
        </Card>

        <Card className='p-2'>
          <div className='text-end'>
            <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg me-1 btn-theme mb-1 rounded-0'>
              {formik.isSubmitting ? (
                <div className='spinner-border spinner-border-sm me-2'></div>
              ) : (
                <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
              )}
              {t('Add')}
            </button>

            <button
              type='button'
              className='btn btn-lg me-1 btn-default mb-1 rounded-0'
              onClick={() => navigate('/PUR/PurchaseRequests', { replace: true })}
            >
              <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
            </button>
          </div>
        </Card>
      </Form>

      {/* ✅ Modal اختيار الوحدة + المخزن + الفئة */}
      <Modal show={showSelectionModal} backdrop='static' keyboard={false} centered className='modal-selection-theme'>
        <Modal.Header className='bg-theme bg-opacity-30 text-white py-3'>
          <Modal.Title className='text-center w-100 h5'>
            <i className='fas fa-sliders-h me-2'></i>
            {t('اختيار الوحدة التشغيلية والمخزن والفئة')}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className='p-4'>
          <div className='text-center mb-4'>
            <div
              className='bg-inverse bg-opacity-25 rounded-circle d-inline-flex align-items-center justify-content-center mb-3'
              style={{ width: '70px', height: '70px' }}
            >
              <i className='fas fa-clipboard-check fs-2 text-theme'></i>
            </div>
            <p className='text-muted mb-0'>يجب اختيار البيانات قبل المتابعة</p>
          </div>

          <div className='row'>
            {/* Operating Unit */}
            <div className='col-12 mb-4'>
              <label className='form-label fw-bold'>{t('الوحدة التشغيليـة')}</label>
              <div className='input-group'>
                <span className='input-group-text bg-inverse bg-opacity-25 border-end-0'>
                  <i className='fas fa-building text-theme'></i>
                </span>

                <Select
                  classNamePrefix='react-select'
                  isLoading={loading3}
                  isSearchable={true}
                  isClearable
                  options={OperatingUnitOptions}
                  value={OperatingUnitOptions?.find((f: any) => f.value === selectedOperatingUnit)}
                  onChange={(option: any) => {
                    setSelectedOperatingUnit(option?.value || null);
                    setSelectedInventory(null); // ✅ سيختار الأول تلقائياً بالـ useEffect
                  }}
                  placeholder={i18n.language === 'ar' ? 'إختر الوحدة التشغيلية' : 'Choose Operating Unit'}
                  className='flex-grow-1'
                />
              </div>
            </div>

            {/* Inventory */}
            <div className='col-12 mb-4'>
              <label className='form-label fw-bold'>{t('المخزن')}</label>
              <div className='input-group'>
                <span className='input-group-text bg-inverse bg-opacity-25 border-end-0'>
                  <i className='fas fa-boxes text-theme'></i>
                </span>

                <Select
                  classNamePrefix='react-select'
                  isLoading={loading4}
                  isSearchable
                  isClearable
                  options={filteredInventoryOptions}
                  value={selectedInventory && filteredInventoryOptions?.find((f: any) => f.value === selectedInventory)}
                  onChange={(option: any) => setSelectedInventory(option?.value || null)}
                  placeholder={i18n.language === 'ar' ? 'إختر المخزن' : 'Choose Inventory'}
                  isDisabled={!selectedOperatingUnit}
                  className='flex-grow-1'
                />
              </div>
            </div>

            {/* Category (✅ fix: dropdown فوق المودال + تظهر الداتا) */}
            <div className='col-12 mb-2'>
              <label className='form-label fw-bold'>{t('الفئة')}</label>

              <div className='input-group'>
                <span className='input-group-text bg-inverse bg-opacity-25 border-end-0'>
                  <i className='fas fa-sitemap text-theme'></i>
                </span>

                <div className='flex-grow-1' style={{ minWidth: 0 }}>
                  <TreeSelect
                    showSearch
                    className='w-100'
                    treeLine
                    allowClear
                    disabled={loading5}
                    value={selectedCategory}
                    onChange={(value: any) => setSelectedCategory(value || null)}
                    treeData={treeCategoriesData}
                    treeNodeFilterProp='title'
                    placeholder={i18n.language === 'ar' ? 'إختر فئة' : 'Choose category'}
                    fieldNames={{ label: 'title', value: 'value', children: 'children' }}
                    treeDefaultExpandAll
                    dropdownStyle={{ maxHeight: 420, overflow: 'auto', zIndex: 2000 }}
                    // ✅ أهم سطرين لحل مشكلة عدم ظهور الداتا داخل مودال Bootstrap
                    getPopupContainer={(triggerNode: any) => triggerNode?.parentElement || document.body}
                    style={{ width: '100%' }}
                  />
                </div>
              </div>

              {loading5 && (
                <small className='text-muted d-block mt-2 text-center'>
                  <i className='fas fa-spinner fa-spin me-1'></i>
                  {t('جاري تحميل الفئات...')}
                </small>
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className='justify-content-center border-top-0 pt-0'>
          <button
            className='btn btn-outline-secondary btn-lg px-4 py-2 me-3'
            onClick={() => navigate('/PUR/PurchaseRequests')}
          >
            <i className='fas fa-times me-2'></i>
            {t('إلغاء')}
          </button>

          <button
            className='btn btn-theme btn-lg px-5 py-2'
            onClick={handleSelectionConfirm}
            disabled={!selectedOperatingUnit || !selectedInventory || !selectedCategory}
          >
            <i className='fas fa-check-circle me-2'></i>
            {t('استمرار')}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Add;
